import { useSearchParams } from 'react-router-dom';
import { SEO } from '../../../seo/useSEO';
import CategoriesTab from './CategoriesTab';
import SizesTab from './SizesTab';
import ColoursTab from './ColoursTab';
import MaterialsTab from './MaterialsTab';
import MeasurementPointsTab from './MeasurementPointsTab';
import TagsTab from './TagsTab';
import GeneralTab from './GeneralTab';

type TabKey = 'geral' | 'categorias' | 'tamanhos' | 'cores' | 'materiais' | 'medidas' | 'tags';

const TABS: ReadonlyArray<{ key: TabKey; label: string }> = [
  { key: 'geral', label: 'Geral' },
  { key: 'categorias', label: 'Categorias' },
  { key: 'tamanhos', label: 'Tamanhos' },
  { key: 'cores', label: 'Cores' },
  { key: 'materiais', label: 'Materiais' },
  { key: 'medidas', label: 'Medidas' },
  { key: 'tags', label: 'Tags' },
];

function isTabKey(value: string | null): value is TabKey {
  return !!value && TABS.some((t) => t.key === value);
}

export default function AdminProductSettingsPage(): JSX.Element {
  const [searchParams, setSearchParams] = useSearchParams();
  const raw = searchParams.get('tab');
  const active: TabKey = isTabKey(raw) ? raw : 'categorias';

  const setActive = (key: TabKey): void => {
    setSearchParams({ tab: key }, { replace: true });
  };

  return (
    <>
      <SEO title="Configurações de produtos (admin)" noindex />
      <h1>Configurações</h1>
      <p className="mt-1 text-sm text-admin-muted">
        Gerir categorias, tamanhos, cores, materiais, medidas e tags reutilizáveis em produtos.
      </p>

      <div
        role="tablist"
        aria-label="Configurações de produtos"
        className="mt-6 flex flex-wrap gap-1 border-b border-admin-border"
      >
        {TABS.map((t) => {
          const selected = t.key === active;
          return (
            <button
              key={t.key}
              type="button"
              role="tab"
              aria-selected={selected}
              onClick={() => setActive(t.key)}
              className={
                selected
                  ? 'rounded-t-md border border-b-0 border-admin-border bg-white px-4 py-2 text-sm font-medium text-admin-primary'
                  : 'rounded-t-md px-4 py-2 text-sm text-admin-muted hover:text-admin-text-soft'
              }
            >
              {t.label}
            </button>
          );
        })}
      </div>

      <div className="mt-6">
        {active === 'geral' ? <GeneralTab /> : null}
        {active === 'categorias' ? <CategoriesTab /> : null}
        {active === 'tamanhos' ? <SizesTab /> : null}
        {active === 'cores' ? <ColoursTab /> : null}
        {active === 'materiais' ? <MaterialsTab /> : null}
        {active === 'medidas' ? <MeasurementPointsTab /> : null}
        {active === 'tags' ? <TagsTab /> : null}
      </div>
    </>
  );
}
